import { render, staticRenderFns } from "./subpackages.vue?vue&type=template&id=2582cef6&scoped=true&"
import script from "./subpackages.vue?vue&type=script&lang=js&"
export * from "./subpackages.vue?vue&type=script&lang=js&"
import style0 from "./subpackages.vue?vue&type=style&index=0&id=2582cef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582cef6",
  null
  
)

export default component.exports